export var EmployeeProfileQueryKey;
(function (EmployeeProfileQueryKey) {
    EmployeeProfileQueryKey["EmployeeProfiles"] = "EmployeeProfiles";
    EmployeeProfileQueryKey["EmployeeProfilesForSelect"] = "EmployeeProfilesForSelect";
})(EmployeeProfileQueryKey || (EmployeeProfileQueryKey = {}));
